import styled from 'styled-components';
import Table, { TableProps } from '@material-ui/core/Table';

export const StyledTable = styled(Table)<TableProps>`
  && {
    border: none;
  }
`;
